module.exports = __webpack_public_path__ + "static/media/avatar-padrao.1a587014.jpg";